module.exports = __webpack_public_path__ + "static/media/mysql.c89c837a.png";